<template>
  <div class="toolbox">
    <a href="#" @click.prevent="backDir" v-if="cwd.folder != 'Root'"><i class="fas fa-arrow-left fa-fw" />Back</a>
    <a href="#" v-if="user && user.superuser" @click.prevent="showNewFolder"><i class="fas fa-plus fa-fw" />New Folder</a>
    <a href="#" v-if="user && user.superuser" @click.prevent="showUpload"><i class="fas fa-file-upload fa-fw" />Upload File</a>
    <span class="vbar"></span>
    
    <!-- <i class="fas fa-sort"></i> -->
    <select v-model="sorting" @change="updateSorting">
      <option value="">Default</option>
      <option value="display_name.asc">A-Z</option>
      <option value="display_name.desc">Z-A</option>
      <option value="created.desc">Newest First</option>
      <option value="created.asc">Oldest First</option>
    </select>

    <span class="vbar"></span>
    <a href="#" @click.prevent="selectAll"><i class="fas fa-fw fa-check-double"></i>Select All</a>

    <template v-if="hasSelection">
      <a href="#" @click.prevent="selectNone"><i class="fas fa-fw fa-border-none"></i>Select None</a>
      <span class="vbar"></span>
      <a href="#" @click.prevent="downloadSelected" class="dl-button">
        <i class="fas fa-fw fa-download" />{{ state == '' ? 'Download Items' : 'Downloading...' }}
        <progress v-if="dlTotal != 0" :max="dlTotal" :value="dlProgress">{{ dlTotal != 0 ? (100 * dlProgress / dlTotal).toFixed(2) : '' }}</progress>
      </a>
    </template>

    <modal ref="folder">
    <h4>New Folder</h4>
    <form @submit.prevent="saveFolder">
      <p>
      <label>Folder Name
        <input autofocus type="text" name="folder_name" v-model="folderName" />
      </label>
      </p>
      <p>
      <button>OK</button>
      <button class="cancel" type="button" @click.prevent="$refs.folder.close()">Cancel</button>
      </p>
    </form>
    </modal>

    <modal ref="upload">
    <upload :path="cwd.folder" @finished="fileUploaded" />
    </modal>
  </div>
</template>
<script>
import axios from 'axios'
import {mapState} from 'vuex'

import Modal from './Modal.vue'
import Upload from './Upload.vue'

const displayToFolder = name => {
  let n = name.replace(/[^a-zA-Z0-9_ ]/g, '')
  return n.replace(/\s+/g, '_')
}

export default {
  name: 'Toolbox',
  components: {Modal, Upload},
  props: ['selected'],
  data() {
    return {
      folderName: '',
      publicFolder: false,
      searchtext: '',
      sorting: '',
      dlProgress: 0,
      dlTotal: 0,
      state: '',
    }
  },
  computed: {
    ...mapState(['cwd', 'user', 'sortMethod']),
    hasSelection() {
      return Array.isArray(this.$props.selected) && this.$props.selected?.length > 0
    },
  },
  methods: {

    async downloadSelected() {
      let file_ids = this.$props.selected?.map(i => i.id)

      let data = {file_ids: file_ids}

      this.state = 'downloading'

      let r = await axios.post('/api/files/bulk-download', data, {
        responseType: 'blob',
        onDownloadProgress: (event) => {
          if (this.dlTotal == 0) {
            this.dlTotal = event.total
          }

          this.dlProgress = event.loaded
        }
      })

      this.state = ''

      if (r.status != 200) {
        $notify.error('An error occurred while bundling your download', 3000);
        return;
      }

      this.dlTotal = 0

      this.downloadStatus = 'client'
      let blobUrl = URL.createObjectURL(r.data)
      let a = document.createElement('A')
      a.download = `bundle.zip`
      a.href = blobUrl
      a.style.display = 'none'

      document.body.append(a)
      a.click()

      setTimeout(() => {
        a.remove()
        URL.revokeObjectURL(blobUrl)

        this.downloadStatus = 'downloaded'
      }, 10)
    },
    selectNone() {
      this.$emit('select-none')
    },
    selectAll() {
      this.$emit('select-all')
    },
    updateSorting() {
      this.$nextTick(() => {
        this.$store.dispatch('setSortMethod', this.sorting)
        this.$store.dispatch('setViewOptions', this.$route.fullPath)
        this.$emit('update-sorting', this.sorting)
      })
    },
    showNewFolder() {
      this.$refs.folder.showModal()
    },
    showUpload() {
      this.$refs.upload.showModal()
    },
    saveFolder() {
      this.$emit('save-folder', {folderName: this.folderName, publicFolder: this.publicFolder})
      this.$refs.folder.close()
      this.folderName = ''
    },
    fileUploaded(info) {
      this.$emit('refresh-items')
      this.$refs.upload.close()
    },
    async backDir() {
      let r = await axios.get(`/api/files/get-parent/${this.cwd.id}`, {
        params: {
          fields: 'id,folder',
        }
      })

      if (r.status != 200) {
        return;
      }

      if (r.data.file == null) {
        this.$router.push('/')
      }
      else {
        this.$router.push(`/${r.data.file.id}`)
      }
    },
    handleShortcut(event) {
      if (event.altKey && event.key == 'n') {
        // console.log('ok')
        this.$refs.folder.showModal();
      }
    },
  },
  mounted() {
    this.sorting = this.sortMethod
    document.addEventListener('keydown', this.handleShortcut)
  },
  beforeUnmount() {
    document.removeEventListener('keydown', this.handleShortcut)
  },
}
</script>
<style lang="scss">
@import '../scss/_include-media.scss';

.toolbox {
  background: #f0f0f0;
  display: inline-flex;
  align-items: center;
  /* margin-right: 20px; */

  .vbar {
    display: block;
    width: 1px;
    height: auto;
    background: #0C6A38;
    align-self: stretch;
    margin: 6px 1rem 6px 0.5rem;
  }


  select {
    box-sizing: border-box;
    margin: 0 0.25rem;
  }

  a {
    padding: 10px;
    text-align: center;
  }

  .dl-button {
    position: relative;

    progress {
      position: absolute;
      width: 100%;
      bottom: 0;
      left: 0;
    }
  }
  dialog {
    // border-radius: 4px;

    button {
      padding: 0.5rem 1rem;

      &:first-child {
        margin-right: 1rem;
      }
    }
  }
}
</style>
